import { setTheme } from "theme/default/setTheme";

export const setBackgroundColor_f0fbff = setTheme(({ theme }) => `background-color: ${theme.colors.color_f0fbff}`);
